import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=be0c0c42&"
import script from "./ClientSelector.vue?vue&type=script&lang=js&"
export * from "./ClientSelector.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelector.vue?vue&type=style&index=0&id=be0c0c42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports